import Icon from 'veui/components/Icon'
import { IconShortVideo } from 'dls-icons-vue'

Icon.register('short-video', IconShortVideo)
